export default {"src":"https://search.testwiggot.com/_next/static/media/for-sale-per-caprate.34b026c4.svg","height":22,"width":51,"blurWidth":0,"blurHeight":0};